<template>
  <div class="next-steps-display">
    <div v-if="headerText" class="steps-header">
      <strong>{{ headerText }}</strong>
    </div>
    <div class="steps-grid">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item"
      >
        {{ step }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NextStepsDisplay',
  props: {
    steps: {
      type: Array,
      required: true,
      // Array of step strings
    },
    headerText: {
      type: String,
      default: 'Next steps:',
    },
  },
  methods: {
    selectStep(step) {
      this.$emit('select', step);
    },
  },
};
</script>

<style scoped lang="scss">
.next-steps-display {
}

.steps-header {
  font-size: 0.9rem;
  color: var(--darkColor);
  margin-bottom: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.steps-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.step-item {
  padding: 10px 12px;
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: normal;
  word-wrap: break-word;
  color: var(--darkColor);
  border-left: 2px solid var(--primaryColor);
  padding-left: 12px;
}

@media (max-width: 768px) {
  .next-steps-display {
    padding-top: 8px;
    margin-top: 8px;
  }

  .steps-header {
    font-size: 0.85rem;
  }

  .step-item {
    font-size: 0.85rem;
    padding: 8px 10px;
  }
}
</style>
